"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectToDataSubspace = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../gen-src/Localize");
var RootReducer_1 = require("../app/RootReducer");
var PrepEmbedding_1 = require("../content/PrepEmbedding");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var PredictiveModelThunk_1 = require("../store/thunk/PredictiveModelThunk");
var Utils_1 = require("../util/Utils");
var Index_1 = require("./base/Index");
var ConnectToDataSubspace = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var getDraftIDResponse = (0, RootReducer_1.useAppSelector)(function (state) { return state.predictiveModel; }).getDraftIDResponse;
    var flowID = (0, react_redux_1.useSelector)(PredictiveModelSlice_1.selectModel).activeVersion.flowId;
    var prepEmbeddingProps = __assign(__assign({}, props.prepEmbeddingProps), { draftid: getDraftIDResponse.currentDraftID });
    var getDraft = function () {
        if (getDraftIDResponse.status !== Utils_1.REDUX_STATUS.idle) {
            return;
        }
        if (flowID && flowID !== '') {
            dispatch((0, PredictiveModelThunk_1.getDraftID)({ flowID: flowID }));
        }
        else {
            dispatch((0, PredictiveModelThunk_1.getDraftID)({}));
        }
    };
    React.useEffect(function () {
        getDraft();
    }, []);
    if ([Utils_1.REDUX_STATUS.idle, Utils_1.REDUX_STATUS.loading].includes(getDraftIDResponse.status)) {
        return React.createElement(Index_1.Loader, null);
    }
    if ([Utils_1.REDUX_STATUS.failed].includes(getDraftIDResponse.status)) {
        (0, PredictiveModelThunk_1.showErrorToast)(Localize_1.Messages.draftIdRetreivalError());
        return null;
    }
    return React.createElement("div", { style: { flex: '1' } }, React.createElement(PrepEmbedding_1.PrepEmbedding, __assign({}, prepEmbeddingProps)));
};
exports.ConnectToDataSubspace = ConnectToDataSubspace;
//# sourceMappingURL=ConnectToDataSubspace.js.map